import { FormlyFieldConfig } from '@ngx-formly/core';
import { FORMLY_FIELD_TYPES, FORMLY_FIELD_WRAPPERS, Masks } from '@app/constants';
import { UnitSetupConfig } from './unit-setup-config.interface';

export const generalInfoTabFields = (config: UnitSetupConfig): FormlyFieldConfig[] => {
	return [
		{
			wrappers: [FORMLY_FIELD_WRAPPERS.customWrapper],
			fieldGroup: districtInformationFieldGroup(config),
		},
		{
			fieldGroup: [
				{
					fieldGroupClassName: 'child-flex-container',
					fieldGroup: [
						{
							className: 'child-flex-item',
							fieldGroup: [
								{
									wrappers: [FORMLY_FIELD_WRAPPERS.customWrapper],
									fieldGroup: [
										{
											type: FORMLY_FIELD_TYPES.headerLabel,
											props: {
												label: 'Tax Identification Numbers',
												useElementH: '5',
												useSecondaryColor: true,
												horizontalLine: true,
												bold: true,
												useDefaultLineColor: true,
												marginBottom: 4,
											},
										},
										{
											fieldGroupClassName: 'row',
											fieldGroup: [
												{
													key: 'FederalTaxID',
													type: FORMLY_FIELD_TYPES.input,
													className: 'col-md-6',
													props: {
														label: 'Federal ID Number',
														required: false,
														maxLength: 10,
														readonly: config.isReadOnly,
													},
												},
												{
													key: 'StateTaxID',
													type: FORMLY_FIELD_TYPES.input,
													className: 'col-md-6',
													props: {
														label: 'State ID Number',
														required: false,
														maxLength: 10,
														readonly: config.isReadOnly,
													},
												},
											],
										},
									],
								},
							],
						},
						{
							className: 'child-flex-item',
							fieldGroup: [
								{
									wrappers: [FORMLY_FIELD_WRAPPERS.customWrapper],
									fieldGroupClassName: '',
									fieldGroup: [
										{
											type: FORMLY_FIELD_TYPES.headerLabel,
											props: {
												label: 'Time Zone Settings',
												useElementH: '5',
												useSecondaryColor: true,
												horizontalLine: true,
												bold: true,
												useDefaultLineColor: true,
												marginBottom: 4,
											},
										},
										{
											fieldGroupClassName: 'row',
											fieldGroup: [
												{
													key: 'TimeZoneId',
													type: FORMLY_FIELD_TYPES.select,
													className: 'col-xs-12 col-sm-6',
													props: {
														label: 'Default Time Zone',
														required: false,
													},
													expressions: {
														'props.options': 'formState.selects.timeZones',
														'props.disabled': () => config.isReadOnly,
													},
												},
												{
													fieldGroupClassName: 'col-md-2 cb-container',
													fieldGroup: [
														{
															key: 'MultipleTimeZones',
															type: FORMLY_FIELD_TYPES.checkbox,
															className: 'cb-default cb-extended',
															props: {
																label: 'Use Multiple Time Zones',
																appearance: 'fill',
																indeterminate: false,
																disabled: config.isReadOnly,
															},
														},
														{
															type: FORMLY_FIELD_TYPES.tooltip,
															props: {
																label: `"Use Multiple Time Zones" when enabled,
																	time zone overrides can be specified for sites as needed in Site Setup.`,
															},
														},
													],
												},
											],
										},
									],
								},
							],
						},
					],
				},
			],
		},
	];
};

const districtInformationFieldGroup = (config: UnitSetupConfig): FormlyFieldConfig[] => {
	return [
		{
			type: FORMLY_FIELD_TYPES.headerLabel,
			props: {
				label: 'District Information',
				useElementH: '5',
				useSecondaryColor: true,
				horizontalLine: true,
				bold: true,
				useDefaultLineColor: true,
				marginBottom: 4,
			},
		},
		{
			fieldGroupClassName: 'row',
			fieldGroup: [
				{
					key: 'Code',
					type: FORMLY_FIELD_TYPES.input,
					className: 'col-md-2',
					props: {
						label: 'Unit Code',
						required: true,
						readonly: true,
						maxLength: 8,
					},
				},
				{
					key: 'UnitName',
					type: FORMLY_FIELD_TYPES.input,
					className: 'col-md-5',
					props: {
						label: 'Unit Name',
						required: true,
						maxLength: 70,
						readonly: config.isReadOnly,
					},
				},
				{
					key: 'OfficialUnitName',
					type: FORMLY_FIELD_TYPES.input,
					className: 'col-md-5',
					props: {
						label: 'Official Name',
						required: true,
						maxLength: 70,
						readonly: config.isReadOnly,
					},
				},
				{
					key: 'Address1',
					type: FORMLY_FIELD_TYPES.input,
					className: 'col-md-6',
					props: {
						label: 'Address 1',
						required: true,
						maxLength: 50,
						readonly: config.isReadOnly,
					},
				},
				{
					key: 'Address2',
					type: FORMLY_FIELD_TYPES.input,
					className: 'col-md-6',
					props: {
						label: 'Address 2',
						maxLength: 50,
						readonly: config.isReadOnly,
					},
				},
				{
					key: 'City',
					type: FORMLY_FIELD_TYPES.input,
					className: 'col-md-6',
					props: {
						label: 'City',
						required: true,
						maxLength: 50,
						readonly: config.isReadOnly,
					},
				},
				{
					key: 'State',
					type: FORMLY_FIELD_TYPES.select,
					className: 'col-md-4',
					props: {
						label: 'State',
						required: true,
						disabled: config.isReadOnly,
					},
					expressions: {
						'props.options': 'formState.selects.states',
					},
				},
				{
					key: 'Zip',
					type: FORMLY_FIELD_TYPES.maskedInput,
					className: 'col-md-2',
					props: {
						label: 'Zip',
						required: true,
						mask: Masks.Zip,
						readonly: config.isReadOnly,
					},
				},
			],
		},
	];
};
